import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { PRINTERS_PERMISSIONS } from "@/app/nav";
import { PrinterDetailPage } from "@/features/printers/PrinterDetailPage";
import { PrinterList } from "@/features/printers/PrinterList";
import { staffRoute } from "@/routes/staff";

/** archived=1 also lists archived profiles. */
export type PrintersSearch = { archived?: 1 };

/** The template and version the alignment page is drawn with. */
export type PrinterDetailSearch = { template?: string; version?: string };

const nonEmpty = (value: unknown) => (typeof value === "string" && value.trim() !== "" ? value.trim() : undefined);

export const printersRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "printers",
  // Set, never omit, each key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): PrintersSearch => ({
    archived: search.archived === 1 || search.archived === "1" ? 1 : undefined,
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, PRINTERS_PERMISSIONS),
  component: PrinterList,
});

export const printerDetailRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "printers/$printerId",
  validateSearch: (search: Record<string, unknown>): PrinterDetailSearch => ({
    template: nonEmpty(search.template),
    version: nonEmpty(search.version),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, PRINTERS_PERMISSIONS),
  component: PrinterDetailPage,
});
